<template>

    <el-row style="height:36px" :gutter="20" type="flex" justify="center">
      <el-pagination
        v-show="total>0"
        :total="total"
        layout="total, prev, pager, next, jumper"
        :page-size="queryParams.page_size"
        :current-page="queryParams.page"
        @current-change="handleCurrentChange"
      />
    </el-row>

</template>

<script>
export default {
  name: 'Pagination',
  components: {},
  props: {
    total: {
      type: Number,
      required: true
    },
    queryParams: {
      type: Object,
      required: true
    }
  },
  methods: {
    // 分页
    handleCurrentChange (newpage) {
      this.queryParams.page = newpage
      this.$emit('getList', this.queryParams)
    }

  }
}
</script>

<style scoped>
    ::v-deep .el-pager li.active {
      color: #4E55AF;
    }
    ::v-deep .el-pager li:hover {
      color: #4E55AF;
    }
</style>
